import { Button, Card, Typography, Divider, Form, Checkbox, Col } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import globalRequest from "../../../utils/global/globalRequest";
import { changeLoader } from "../../../redux/reducers/loader";
import * as Apis from "../../../utils/helper/enum";
import { convertValueToLable } from "../../../utils/helper/utils";

const daysName = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

const DropZoneSlot = () => {
  const navigate = useNavigate();

  const handleTimeSlotClick = (day, index) => {
    setTimeSlots((prevSlots) => {
      const updatedSlots = { ...prevSlots };

      // Toggle the 'check' property for the specific time slot
      updatedSlots[day][index].check = !updatedSlots[day][index].check;

      return updatedSlots;
    });
  };

  const dispatch = useDispatch();
  let { id } = useParams();

  const [timeSlots, setTimeSlots] = useState({
    1: [], // Sunday
    2: [], // Monday
    3: [], // Tuesday
    4: [], // Wednesday
    5: [], // Thursday
    6: [], // Friday
    7: [], // Saturday
  });

  const [setEdit] = useState(false); //edit

  // const validateSlots = () => {
  //   let hasError = false;
  //   const newSlots = { ...timeSlots };

  //   Object.keys(newSlots).forEach((day) => {
  //     newSlots[day].forEach((slot, index) => {
  //       if (!slot.openTime) {
  //         newSlots[day][index].openTimeErr = "Open time is required.";
  //         hasError = true;
  //       }
  //       if (!slot.closeTime) {
  //         newSlots[day][index].closeTimeErr = "Close time is required.";
  //         hasError = true;
  //       }
  //       if (!slot.capacity) {
  //         newSlots[day][index].capacityErr = "Capacity is required.";
  //         hasError = true;
  //       }

  //       // Validate that closeTime is greater than openTime
  //       if (slot.openTime && slot.closeTime && slot.closeTime <= slot.openTime) {
  //         newSlots[day][index].closeTimeErr = "Close time must be greater than open time.";
  //         hasError = true;
  //       }

  //     });
  //   });

  //   setTimeSlots(newSlots);
  //   return !hasError;
  // };

  const handleSubmit = async () => {
    let insertData = [];
    let errorToken = true;

    for (let key in timeSlots) {
      let item = timeSlots[key];
      if (item.length > 0) {
        for (let itm of item) {
          if (itm.check === true) {
            errorToken = false;
            insertData.push({
              id: itm.id,
              day: itm.day,
              openTime: itm.openTime,
              closeTime: itm.closeTime,
              capacity: itm.capacity,
            });
          }
        }
      }
    }

    if (errorToken) {
      toast.error("please select any slot");
      return;
    }

    let time_slots = [];

    for (let i in timeSlots) {
      if (timeSlots[i].length > 0) {
        let slots = [];
        for (let j in timeSlots[i]) {
          slots.push({
            openTime: timeSlots[i][j].openTime,
            closeTime: timeSlots[i][j].closeTime,
            capacity: timeSlots[i][j].capacity,
          });
        }
        time_slots.push({
          day: daysName[i - 1].toLowerCase(),
          slots: slots,
        });
      }
    }

    let insertArray = {
      dropzone_id: id,
      time_slot_json: insertData,
    };

    dispatch(changeLoader(true));
    try {
      let url = Apis?.MANAGE_DROPZONE?.ADD_DROPZONE_TIMESLOT;
      let method = "post";
      let response = await globalRequest(url, method, insertArray, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Working hours added successfully";
        if (id) msg = "Working hours updated successfully";
        toast.success(msg, {
          duration: 2000,
        });
        localStorage.setItem("currentTab", "2");
        navigate("/edit-drop-zone/" + id);
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  const getTimeSlotes = async (id, branchDetail1) => {
    // let params = {
    //   id:id
    // }
    try {
      let response = await globalRequest(
        Apis.MANAGE_DROPZONE.GET_DROPZONE_TIMESLOT_LIST + "/" + id,
        "get",
        {},
        {}, //params:params
        true
      );
      let apiResponse = response?.data;

      if (!apiResponse?.data) setEdit(false);
      else {
        setEdit(true);
        let data = apiResponse.data;

        let sunday = [];
        let monday = [];
        let tuesday = [];
        let wednesday = [];
        let thursday = [];
        let friday = [];
        let saturday = [];
        for (let i in data) {
          let check = false;
          // branchDetail.timeSlotJson
          if (branchDetail1?.timeSlotJson?.length > 0)
            for (let item of branchDetail1.timeSlotJson) {
              if (item.id === data[i].id) check = true;
            }

          if (data[i].day === "sunday")
            sunday.push({
              openTime: data[i].openTime,
              closeTime: data[i].closeTime,
              capacity: data[i].capacity,
              openTimeErr: null,
              closeTimeErr: null,
              capacityErr: null,
              id: data[i].id,
              check: check,
              day: "sunday",
            });
          if (data[i].day === "monday")
            monday.push({
              openTime: data[i].openTime,
              closeTime: data[i].closeTime,
              capacity: data[i].capacity,
              openTimeErr: null,
              closeTimeErr: null,
              capacityErr: null,
              id: data[i].id,
              check: check,
              day: "monday",
            });
          if (data[i].day === "tuesday")
            tuesday.push({
              openTime: data[i].openTime,
              closeTime: data[i].closeTime,
              capacity: data[i].capacity,
              openTimeErr: null,
              closeTimeErr: null,
              capacityErr: null,
              id: data[i].id,
              check: check,
              day: "tuesday",
            });
          if (data[i].day === "wednesday")
            wednesday.push({
              openTime: data[i].openTime,
              closeTime: data[i].closeTime,
              capacity: data[i].capacity,
              openTimeErr: null,
              closeTimeErr: null,
              capacityErr: null,
              id: data[i].id,
              check: check,
              day: "wednesday",
            });
          if (data[i].day === "thursday")
            thursday.push({
              openTime: data[i].openTime,
              closeTime: data[i].closeTime,
              capacity: data[i].capacity,
              openTimeErr: null,
              closeTimeErr: null,
              capacityErr: null,
              id: data[i].id,
              check: check,
              day: "thursday",
            });
          if (data[i].day === "friday")
            friday.push({
              openTime: data[i].openTime,
              closeTime: data[i].closeTime,
              capacity: data[i].capacity,
              openTimeErr: null,
              closeTimeErr: null,
              capacityErr: null,
              id: data[i].id,
              check: check,
              day: "friday",
            });
          if (data[i].day === "saturday")
            saturday.push({
              openTime: data[i].openTime,
              closeTime: data[i].closeTime,
              capacity: data[i].capacity,
              openTimeErr: null,
              closeTimeErr: null,
              capacityErr: null,
              id: data[i].id,
              check: check,
              day: "saturday",
            });
        }

        setTimeSlots({
          1: [...sunday], // Sunday
          2: [...monday], // Monday
          3: [...tuesday], // Tuesday
          4: [...wednesday], // Wednesday
          5: [...thursday], // Thursday
          6: [...friday], // Friday
          7: [...saturday], // Saturday
        });
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  useEffect(() => {
    getDropZoneDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getDropZoneDetail = async () => {
    try {
      let response = await globalRequest(Apis.MANAGE_DROPZONE.GET_DETAIL + "/" + id, "get", {}, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let data = apiResponse?.data;
        getTimeSlotes(id, data);
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  return (
    <>
      <Card>
        <div className="">
          <Typography className="text-xl font-semibold" align={"left"}>
            <LeftOutlined className="mr-2" onClick={() => navigate(-1)} />
            Edit Slot
          </Typography>
        </div>
        <Divider />
        <div className="min-h-[calc(100vh_-_305px)]">
          <Form
            layout="vertical"
            initialValues={{
              remember: true,
            }}
            autoComplete="off"
          >
            {/* <Checkbox.Group className="w-full">
                <div className="font-semibold mr-[50px] w-[100px] mt-4">Sunday</div>
                <Row gutter={16}>
                  <Col span={4}>
                    <div
                      className={`w-full rounded-lg py-3 px-1.5 text-center text-sm ${
                        selectedTimeSlots["02:00 PM - 04:00 PM"]
                          ? "bg-green-100 text-white"
                          : "bg-gray-100 text-gray-500"
                      } my-2`}
                      onClick={() => handleTimeSlotClick("02:00 PM - 04:00 PM")}
                    >
                      02:00 PM - 04:00 PM
                    </div>
                  </Col>
                  <Col span={4}>
                    <div
                      className="w-full rounded-lg bg-gray-100 py-3 px-1.5 text-center text-sm text-gray-500 my-2"
                    >
                      02:00 PM - 04:00 PM
                    </div>
                  </Col>
                  <Col span={4}>
                    <div
                      className="w-full rounded-lg bg-gray-100 py-3 px-1.5 text-center text-sm text-gray-500 my-2"
                    >
                      02:00 PM - 04:00 PM
                    </div>
                  </Col>
                  <Col span={4}>
                    <div className="w-full rounded-lg bg-gray-100 py-3 px-1.5 text-center text-sm text-gray-500 my-2">
                      02:00 PM - 04:00 PM
                    </div>
                  </Col>
                </Row>
                <Divider />
  
                <div className="font-semibold mr-[50px] w-[100px] mt-4">Monday</div>
                <Row gutter={16}>
                  <Col span={4}>
                    <div className="w-full rounded-lg bg-gray-100 py-3 px-1.5 text-center text-sm text-gray-500 my-2">
                      02:00 PM - 04:00 PM
                    </div>
                  </Col>
                  <Col span={4}>
                    <div className="w-full rounded-lg bg-gray-100 py-3 px-1.5 text-center text-sm text-gray-500 my-2">
                      02:00 PM - 04:00 PM
                    </div>
                  </Col>
                  <Col span={4}>
                    <div className="w-full rounded-lg bg-gray-100 py-3 px-1.5 text-center text-sm text-gray-500 my-2">
                      02:00 PM - 04:00 PM
                    </div>
                  </Col>
                </Row>
                <Divider />
  
                <div className="font-semibold mr-[50px] w-[100px] mt-4">Tuesday</div>
                <Row gutter={16}>
                  <Col span={4}>
                    <div className="w-full rounded-lg bg-gray-100 py-3 px-1.5 text-center text-sm text-gray-500 my-2">
                      02:00 PM - 04:00 PM
                    </div>
                  </Col>
                </Row>
                <Divider />
  
                <div className="font-semibold mr-[50px] w-[100px] mt-4">Wednesday</div>
                <Row gutter={16}>
                  <Col span={4}>
                    <div className="w-full rounded-lg bg-gray-100 py-3 px-1.5 text-center text-sm text-gray-500 my-2">
                      02:00 PM - 04:00 PM
                    </div>
                  </Col>
                  <Col span={4}>
                    <div className="w-full rounded-lg bg-gray-100 py-3 px-1.5 text-center text-sm text-gray-500 my-2">
                      02:00 PM - 04:00 PM
                    </div>
                  </Col>
                  <Col span={4}>
                    <div className="w-full rounded-lg bg-gray-100 py-3 px-1.5 text-center text-sm text-gray-500 my-2">
                      02:00 PM - 04:00 PM
                    </div>
                  </Col>
                  <Col span={4}>
                    <div className="w-full rounded-lg bg-gray-100 py-3 px-1.5 text-center text-sm text-gray-500 my-2">
                      02:00 PM - 04:00 PM
                    </div>
                  </Col>
                </Row>
                <Divider />
  
                <div className="font-semibold mr-[50px] w-[100px] mt-4">Thursday</div>
                <Row gutter={16}>
                  <Col span={4}>
                    <div className="w-full rounded-lg bg-gray-100 py-3 px-1.5 text-center text-sm text-gray-500 my-2">
                      02:00 PM - 04:00 PM
                    </div>
                  </Col>
                  <Col span={4}>
                    <div className="w-full rounded-lg bg-gray-100 py-3 px-1.5 text-center text-sm text-gray-500 my-2">
                      02:00 PM - 04:00 PM
                    </div>
                  </Col>
                </Row>
                <Divider />
                <div className="font-semibold mr-[50px] w-[100px] mt-4">Friday</div>
                <Row gutter={16}>
                  <Col span={4}>
                    <div className="w-full rounded-lg bg-gray-100 py-3 px-1.5 text-center text-sm text-gray-500 my-2">
                      02:00 PM - 04:00 PM
                    </div>
                  </Col>
                  <Col span={4}>
                    <div className="w-full rounded-lg bg-gray-100 py-3 px-1.5 text-center text-sm text-gray-500 my-2">
                      02:00 PM - 04:00 PM
                    </div>
                  </Col>
                  <Col span={4}>
                    <div className="w-full rounded-lg bg-gray-100 py-3 px-1.5 text-center text-sm text-gray-500 my-2">
                      02:00 PM - 04:00 PM
                    </div>
                  </Col>
                  <Col span={4}>
                    <div className="w-full rounded-lg bg-gray-100 py-3 px-1.5 text-center text-sm text-gray-500 my-2">
                      02:00 PM - 04:00 PM
                    </div>
                  </Col>
                </Row>
                <Divider />
                <div className="font-semibold mr-[50px] w-[100px] mt-4">Saturday</div>
                <Row gutter={16}>
                  <Col span={4}>
                    <div className="w-full rounded-lg bg-gray-100 py-3 px-1.5 text-center text-sm text-gray-500 my-2">
                      02:00 PM - 04:00 PM
                    </div>
                  </Col>
                </Row>
                <Divider />
  
                <Divider />
              </Checkbox.Group> */}

            <Checkbox.Group className="w-full">
              {Object.keys(timeSlots).map((day) => (
                <>
                  <div className="font-semibold mr-[50px] w-[100px] mt-4">{daysName[day - 1]}</div>
                  {timeSlots[day]?.map((slot, index) =>
                    slot ? (
                      <Col span={4} key={index}>
                        <div
                          className={`w-full rounded-lg py-3 px-1.5 text-center text-sm cursor-pointer ${
                            slot.check ? "bg-green-100 text-white" : "bg-gray-100 text-gray-500"
                          } my-2`}
                          onClick={() => handleTimeSlotClick(day, index)}
                        >
                          {convertValueToLable(slot.openTime)} - {convertValueToLable(slot.closeTime)}
                        </div>
                      </Col>
                    ) : null
                  )}
                  <Divider className="mt-5" />
                </>
              ))}

              <Divider />
            </Checkbox.Group>
          </Form>
          <div className="flex justify-end gap-3">
            <Button onClick={() => navigate("/edit-dropzone-slot/" + id)}>Cancel</Button>
            <Button type="primary" onClick={() => handleSubmit()}>
              Save
            </Button>
          </div>
        </div>
      </Card>
    </>
  );
};
export default DropZoneSlot;
